var utils = require('../../utils')

export default {
  name: 'reset-password',
  utils: utils,
  data: function () {
    return {
      canValidate: true,
      password: null,
      password_retyped: null,
      isSuccess: false,
      message: null,
      showMessage: false
    }
  },
  created: function () {
    this.$store.dispatch('CLEAR_AUTH_STATUS')
  },
  computed: {
    isResetPasswordSuccess () {
      return (this.$store.getters.authStatus === 'success')
    },
    validation: function() {
      var pass = /^\w{4,10}$/
      var v = {
        password_rule: (pass.test(this.password) || !this.password),
        password_retyped: this.password == this.password_retyped,

        not_input: (pass.test(this.password) || !this.password) &&
                   this.password == this.password_retyped
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  methods: {
    /** パスワードリセット */
    reset: function () {
      this.canValidate = true
      if (this.isValid) {
        console.log("is valid")
        this.showMessage = false
        var form = new FormData()
        form.append('password', this.password)
        form.append('token', this.$route.query.token)
        this.$store.dispatch('PASSWORD_RESET_UPDATE', {data: form})
        .then(
          (res) => {
            this.message = this.$t('reset_password.completed')
            this.showMessage = true
          },
          () => {
            this.message = this.$store.getters.authError || this.$store.getters.apiError
            this.showMessage = true
          }
        )
      } else {
        console.log("need edit")
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/reset-password.js